export const elgs = [
  { label: 'PWD', value: 'PWD' },
  { label: 'Arabs@', value: 'Arabs@' },
  { label: 'Asians@', value: 'Asians@' },
  { label: 'AWE', value: 'AWE' },
  { label: 'BEN', value: 'BEN' },
  { label: 'BPP', value: 'BPP' },
  { label: 'Connect@', value: 'Connect@' },
  { label: 'Families@', value: 'Families@' },
  { label: 'Glamazon', value: 'Glamazon' },
  { label: 'Inclusion Ambassadors', value: 'Inclusion Ambassadors' },
  { label: 'Indigenous@', value: 'Indigenous@' },
  { label: 'Jewish@', value: 'Jewish@' },
  { label: 'Latinos@', value: 'Latinos@' },
  { label: 'MHW', value: 'MHW' },
  { label: 'Sustainability', value: 'Sustainability' },
  { label: 'Trans@', value: 'Trans@' },
  { label: 'Warriors@', value: 'Warriors@' },
  { label: 'Women in Finance', value: 'Women in Finance' },
  { label: 'Women@', value: 'Women@' },
];
